import { FC } from 'react';
import { Row, styled } from '@streem/ui-react';
import { CollapsibleContent } from './collapsible_content';
import { RoomNote } from '../tabs/summary/notes/room_note';

export const CallDetailNotes: FC = () => {
    return (
        <Section>
            <CollapsibleContent title="Notes" id="post-call-notes" initialExpandedYn>
                <CallDetailWrapper>
                    <RoomNote />
                </CallDetailWrapper>
            </CollapsibleContent>
        </Section>
    );
};

const CallDetailWrapper = styled(Row)({
    columnGap: '2rem',
    margin: '1rem 0',
});

const Section = styled('section')({
    margin: '24px 0 24px 0',
});
